import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Action, getModule, Mutation } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { getTenantId } from "@/store/helper";
import _ from "lodash";
import { GuidItemModel } from "../models/shared/guidItem";
import { plainToClass } from "class-transformer";
import { CalendarEventModel } from "../models/calendarEvent/calendarEvent";
import { CalendarEventSaveModel } from "../models/calendarEvent/calendarEventSaveDTO";
import { Guid } from "guid-typescript";
import { ICalendarEventRequestDTO } from "../models/calendarEvent/calendarEventRequestDTO";
import { CalendarEventViewModel } from "../models/calendarEvent/calendarEventViewDTO";
import { GridOptionModel } from "../models/shared/gridOption";
let CalendarEventsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    let CalendarEventsModule = class CalendarEventsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "CalendarEvent";
            this.editCalendarEvent = null;
            this.calendarEvents = [];
            this.viewCalendarEvent = [];
            this.states = [];
            this.totalCount = 0;
            this.searchParams = null;
        }
        async GetCalendarEvents(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.setCalendarEvents(plainToClass(CalendarEventModel, data.calendarEvents));
                this.SetStates(plainToClass(GuidItemModel, data.states));
                this.setTotalCount(plainToClass(GuidItemModel, data.totalCount));
                return data;
            }
        }
        async GetMasterDataForAddCalendarEvent() {
            var url = `${getTenantId()}/${this.apiNode}/add/defaults`;
            let { data } = await service.get(url);
            if (data) {
                this.SetStates(plainToClass(GuidItemModel, data.states));
                return data;
            }
        }
        async SaveCalendarEvent(CalendarEvent) {
            var url = `${getTenantId()}/${this.apiNode}/save`;
            let { data } = await service.post(url, CalendarEvent);
            if (data) {
                return data;
            }
        }
        async GetCalendarEvent(eventId) {
            var url = `${getTenantId()}/${this.apiNode}/edit/` + eventId;
            let { data } = await service.get(url);
            if (data) {
                this.setCalendarEvent(plainToClass(CalendarEventSaveModel, data.calendarEvent));
                this.SetStates(plainToClass(GuidItemModel, data.states));
                return data;
            }
        }
        async UpdateCalendarEvent(CalendarEvent) {
            var url = `${getTenantId()}/${this.apiNode}/update`;
            let { data } = await service.post(url, CalendarEvent);
            if (data) {
                return data;
            }
        }
        async DeleteCalendarEvent(eventId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/` + eventId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async GetEventsForCalendarView(calendarEventRequest) {
            var url = `${getTenantId()}/${this.apiNode}/view`;
            let { data } = await service.post(url, calendarEventRequest);
            if (data) {
                this.setCalendarEventsForView(plainToClass(CalendarEventViewModel, data.calendarEvents));
                this.SetStates(plainToClass(GuidItemModel, data.states));
                return data;
            }
        }
        async ValidateRecurrenceRule(rule) {
            var ruleModel = new GuidItemModel();
            ruleModel.value = rule;
            var url = `${getTenantId()}/${this.apiNode}/validate-recurrence-rule`;
            let { data } = await service.post(url, ruleModel);
            if (data) {
                return data;
            }
        }
        AssignSearchParams(param) {
            this.searchParams = _.cloneDeep(param);
        }
        ClearSearchParams() {
            this.searchParams = null;
        }
        setCalendarEventsForView(calendarEvents) {
            this.viewCalendarEvent = calendarEvents;
        }
        setCalendarEvents(calendarEvents) {
            this.calendarEvents = calendarEvents;
        }
        setCalendarEvent(calendarEvents) {
            this.editCalendarEvent = calendarEvents;
        }
        SetStates(states) {
            this.states = states;
        }
        setTotalCount(totalCount) {
            this.totalCount = totalCount;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof GridOptionModel !== "undefined" && GridOptionModel) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], CalendarEventsModule.prototype, "GetCalendarEvents", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], CalendarEventsModule.prototype, "GetMasterDataForAddCalendarEvent", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof CalendarEventSaveModel !== "undefined" && CalendarEventSaveModel) === "function" ? _d : Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], CalendarEventsModule.prototype, "SaveCalendarEvent", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], CalendarEventsModule.prototype, "GetCalendarEvent", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof CalendarEventSaveModel !== "undefined" && CalendarEventSaveModel) === "function" ? _g : Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], CalendarEventsModule.prototype, "UpdateCalendarEvent", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof Guid !== "undefined" && Guid) === "function" ? _j : Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], CalendarEventsModule.prototype, "DeleteCalendarEvent", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof ICalendarEventRequestDTO !== "undefined" && ICalendarEventRequestDTO) === "function" ? _l : Object]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], CalendarEventsModule.prototype, "GetEventsForCalendarView", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], CalendarEventsModule.prototype, "ValidateRecurrenceRule", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof GridOptionModel !== "undefined" && GridOptionModel) === "function" ? _p : Object]),
        __metadata("design:returntype", void 0)
    ], CalendarEventsModule.prototype, "AssignSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CalendarEventsModule.prototype, "ClearSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CalendarEventsModule.prototype, "setCalendarEventsForView", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CalendarEventsModule.prototype, "setCalendarEvents", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CalendarEventsModule.prototype, "setCalendarEvent", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CalendarEventsModule.prototype, "SetStates", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CalendarEventsModule.prototype, "setTotalCount", null);
    CalendarEventsModule = __decorate([
        Module({ dynamic: true, store: store, name: "CalendarEvents", namespaced: true })
    ], CalendarEventsModule);
    return CalendarEventsModule;
})();
export const CalendarEventModule = getModule(CalendarEventsModule);
